import * as ChannelService from '@channel.io/channel-web-sdk-loader'

// 스크립트 로드
ChannelService.loadScript()

ChannelService.boot({
  pluginKey: process.env.GATSBY_CHANNEL_TALK_PLUGIN_KEY,
})
